import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
const SpinnerContext = createContext();

export function SpinnerProvider({ children }) {

  const [spinner, setSpinner] = useState([]);
  const addToSpinner = useCallback(() => {
    setSpinner(prevSpinner => [...prevSpinner, 1]);
  }, []);
  const removeToSpinner = useCallback(() => {
    setSpinner(prevSpinner => prevSpinner.slice(0, -1));
  }, []);
  const value = useMemo(
    () => ({ spinner, addToSpinner, removeToSpinner }),
    [spinner, addToSpinner, removeToSpinner]
  );
  return (
    <SpinnerContext.Provider value={value}>
      {children}
    </SpinnerContext.Provider>
  );
}

export function useSpinner() {
  return useContext(SpinnerContext);
}